var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.70105 15.75C7.83271 15.978 8.02206 16.1674 8.25008 16.299C8.4781 16.4306 8.73676 16.4999 9.00005 16.4999C9.26334 16.4999 9.522 16.4306 9.75002 16.299C9.97804 16.1674 10.1674 15.978 10.2991 15.75M2.4465 11.4945C2.34852 11.6019 2.28387 11.7354 2.26039 11.8789C2.23692 12.0223 2.25564 12.1695 2.31428 12.3025C2.37292 12.4356 2.46895 12.5487 2.59069 12.6281C2.71243 12.7075 2.85464 12.7499 3 12.75H15C15.1454 12.7501 15.2876 12.7079 15.4094 12.6286C15.5312 12.5493 15.6274 12.4363 15.6862 12.3034C15.745 12.1705 15.7639 12.0233 15.7406 11.8798C15.7173 11.7364 15.6528 11.6028 15.555 11.4952C14.5575 10.467 13.5 9.37425 13.5 6C13.5 4.80653 13.0259 3.66193 12.182 2.81802C11.3381 1.97411 10.1935 1.5 9 1.5C7.80653 1.5 6.66193 1.97411 5.81802 2.81802C4.97411 3.66193 4.5 4.80653 4.5 6C4.5 9.37425 3.44175 10.467 2.4465 11.4945Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminder-icon.6194c753f365662f67f3da3fab5d6153.svg";
export { ForwardRef as ReactComponent };